// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Accounts_Types_Id from "../Restaumatic.Accounts.Types.Id/index.js";
import * as Restaumatic_Countries from "../Restaumatic.Countries/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Geocoding_Types_StreetAddress from "../Restaumatic.Geocoding.Types.StreetAddress/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Accounts_Types_Id.eqAccountId));
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Countries.eqCountry);
var eq2 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqBoolean));
var eq3 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Restaurant_Types_Id.eqRestaurantId));
var eq4 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Geocoding_Types_StreetAddress.eqStreetAddress);
var accountIdIsSymbol = {
    reflectSymbol: function () {
        return "accountId";
    }
};
var countryIsSymbol = {
    reflectSymbol: function () {
        return "country";
    }
};
var fromPSIsSymbol = {
    reflectSymbol: function () {
        return "fromPS";
    }
};
var restaurantIdIsSymbol = {
    reflectSymbol: function () {
        return "restaurantId";
    }
};
var streetAddressIsSymbol = {
    reflectSymbol: function () {
        return "streetAddress";
    }
};
var GeocodeRequestIsSymbol = {
    reflectSymbol: function () {
        return "GeocodeRequest";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var GeocodeRequest = function (x) {
    return x;
};
var toFillFormTypeGeocodeRequ = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var rPCSitesGeocodeRequestGeo = {};
var rPCMethodNameGeocodeReque = {
    rpcMethodName: function (v) {
        return "GeocodeRequest";
    }
};
var newtypeGeocodeRequest_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldGeocodeRequest = function (dictHasField) {
    return dictHasField;
};
var eqGeocodeRequest = {
    eq: function (x) {
        return function (y) {
            return eq(x.accountId)(y.accountId) && eq1(x.country)(y.country) && eq2(x.fromPS)(y.fromPS) && eq3(x.restaurantId)(y.restaurantId) && eq4(x.streetAddress)(y.streetAddress);
        };
    }
};
var genericGeocodeRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGeocodeRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGeocodeRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(accountIdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(countryIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(fromPSIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantIdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streetAddressIsSymbol)(Restaumatic_Geocoding_Types_StreetAddress.showStreetAddress))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Restaurant_Types_Id.showRestaurantId)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showBoolean)))(Restaumatic_Countries.showCountry))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Accounts_Types_Id.showAccountId)))))(GeocodeRequestIsSymbol))
};
var unscrambleDecodeGeocodeRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGeocodeRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(accountIdIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Accounts_Types_Id.udecodeAccountId))(/* #__PURE__ */ Unscramble.decodeRecordCons(countryIsSymbol)(Restaumatic_Countries.unscrambleDecodeCountry)(/* #__PURE__ */ Unscramble.decodeRecordCons(fromPSIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantIdIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId))(/* #__PURE__ */ Unscramble.decodeRecordCons(streetAddressIsSymbol)(Restaumatic_Geocoding_Types_StreetAddress.unscrambleDecodeStreetAddress)(Unscramble.decodeRecordNil)))))))))(Unscramble_Generic.defaultOptions)
};
var encodeGeocodeRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGeocodeRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(GeocodeRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(streetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Geocoding_Types_StreetAddress.encodeStreetAddress)))(restaurantIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Restaurant_Types_Id.encodeRestaurantId))))(fromPSIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.booleanEncode))))(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Countries.encodeCountry)))(accountIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Accounts_Types_Id.encodeAccountId)))))))
};
var decodeGeocodeRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGeocodeRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(GeocodeRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(streetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Geocoding_Types_StreetAddress.decodeStreetAddress))())(restaurantIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Restaurant_Types_Id.decodeRestaurantId)))())(fromPSIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.booleanDecode)))())(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Countries.decodeCountry))())(accountIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Accounts_Types_Id.decodeAccountId)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    GeocodeRequest,
    genericGeocodeRequest,
    eqGeocodeRequest,
    showGeocodeRequest,
    rPCMethodNameGeocodeReque,
    rPCSitesGeocodeRequestGeo,
    encodeGeocodeRequest,
    decodeGeocodeRequest,
    unscrambleDecodeGeocodeRequest,
    toFillFormTypeGeocodeRequ,
    hasFieldGeocodeRequest,
    newtypeGeocodeRequest_
};
